import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { ResourceModel } from "../shared/models/ResourceModel";

export class MaintenanceUtil {

    // Dates are in the American format (mm/dd/yyyy)
    private static readonly cutoverDStart = new Date('01/13/2022 18:00');
    private static readonly cutoverDEnd = new Date('01/16/2022 18:00');
    private static readonly cutoverQStart = new Date('02/10/2022 18:00');
    private static readonly cutoverQEnd = new Date('02/13/2022 18:00');
    private static readonly cutoverPStart = new Date('04/14/2022 18:00');
    private static readonly cutoverPEnd = new Date('04/18/2022 18:00');

    public static async callMaintenanceApi(apiUrl: string, appIsInMaintenance: boolean) {
        if (!apiUrl) {
            console.error('Please add the Maintenance API URLs in your config files');
        }
        await fetch(apiUrl).then(res => res.text()).then(isInMaintenance => {
            if ((isInMaintenance === 'true') || appIsInMaintenance) {
                void this.redirectToMaintenancePage();
            }
            else{
                sessionStorage.removeItem("MTextFr");
                sessionStorage.removeItem("MTextNl");
            }
        });
    }

    public static async redirectToMaintenancePage() {
        const today = new Date();
        const isCutover = this.checkDateInterval(this.cutoverDStart, this.cutoverDEnd, today) ||
            this.checkDateInterval(this.cutoverQStart, this.cutoverQEnd, today) ||
            this.checkDateInterval(this.cutoverPStart, this.cutoverPEnd, today);
        const sorryPage = isCutover ? '/sorry-cutover.html' : '/sorry.html';
        await fetch(`${<string>AgAppConfigService.settings.applicativeApiUrl}/fr/silcommon/resources`).then(res => res?.json()).then((res: {Result: ResourceModel[]}) => {
            const result = res.Result;
            const maintenanceSessionValue = result.find(x=>x.Name === "AGMaintenanceMessageLead");
            sessionStorage.MTextFr = maintenanceSessionValue.FrenchValue;
            sessionStorage.MTextNl = maintenanceSessionValue.DutchValue;
        });
        if (!window.location.origin.includes("localhost")){ // for hosted environment
            window.location.href = window.location.origin + '/easyinvest'+ sorryPage;
        }else{ // for local environment
            window.location.href = window.location.origin + sorryPage;
        }
    }

    private static checkDateInterval(from: Date, to: Date, date: Date) {
        return (date >= from && date <= to);
    }
}
